/**
 * Get the value for a given feature flag. If a default value is not provided,
 * null is used as a default.
 *
 * Avoid calling this method at the top-level scope of modules, and don't try to
 * cache values. Try to make checking a flag as lazy as possible.
 */

export function getFeatureFlagValue(flagName) {
  var _getOrCreateContainer, _provider$getValue;
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var provider = (_getOrCreateContainer = getOrCreateContainer()) === null || _getOrCreateContainer === void 0 ? void 0 : _getOrCreateContainer.v1;
  if (!provider) {
    return defaultValue;
  }
  return (_provider$getValue = provider.getValue(flagName)) !== null && _provider$getValue !== void 0 ? _provider$getValue : defaultValue;
}
/**
 * Installs a feature flag provider for consumers to use.
 *
 * This should only be done in a host application, or in tests of a library.
 * Libraries should never install a provider in published code.
 */
export function installProvider(provider) {
  var container = getOrCreateContainer();
  if (container) {
    container.v1 = provider;
  }
}
function getOrCreateContainer() {
  var _ref, _ref$__citrix_interna;
  if (typeof window === 'undefined') {
    return undefined;
  }
  (_ref$__citrix_interna = (_ref = window).__citrix_internal_featureflags__) !== null && _ref$__citrix_interna !== void 0 ? _ref$__citrix_interna : _ref.__citrix_internal_featureflags__ = {};
  return window.__citrix_internal_featureflags__;
}